import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll to the top whenever the route changes.
 * Without this, React Router preserves the previous scroll position
 * (the browser does too, but only for back/forward navigations), which
 * makes new product pages open mid-scroll.
 *
 * Mount it once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // `auto` (not `smooth`) to feel instant on click — smooth would animate
    // visibly upward and confuse users.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}
